import { render } from "./Profile.vue?vue&type=template&id=7a2b6835"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Profile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a2b6835"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a2b6835', __exports__)) {
    api.reload('7a2b6835', __exports__)
  }
  
  module.hot.accept("./Profile.vue?vue&type=template&id=7a2b6835", () => {
    api.rerender('7a2b6835', render)
  })

}


export default __exports__